// deps
import { useRef, useMemo } from "react";

// constants
import browser from "../../constants/browser";

function getCover(cover) {
  if (browser && cover instanceof File) {
    return URL.createObjectURL(cover);
  }
}

/**
 * Retourne un objet sérialisable comptatible avec l’attribut `src` d’une image.
 * @param {File | string} value
 * @return {string}
 */
export default function useCoversFile(value) {
  const previousCover = useRef();

  const cover = useMemo(
    function () {
      let cover = value;

      if (browser && cover instanceof File) {
        cover = getCover(value);
      }

      if (browser && previousCover.current instanceof Blob) {
        URL.revokeObjectURL(previousCover.current);
      }

      previousCover.current = cover;

      return cover;
    },
    [value],
  );

  return cover;
}
